module.exports = __webpack_public_path__ + "static/media/hero.e82679f2.jpg";